import { DropzoneAccept } from '../dropzone.types';

const extensionToMime: Record<string, string> = {
  // Video types
  '.mp4': 'video/mp4',
  '.avi': 'video/avi',
  '.wmv': 'video/x-ms-wmv',
  '.mpg': 'video/mpeg',
  '.gvf': 'application/octet-stream', // # Proprietary format for PillCam SB3

  // Image types
  '.jpeg': 'image/jpeg',
  '.jpg': 'image/jpeg',
  '.png': 'image/png',
};

const imageExtensions = ['.jpeg', '.jpg', '.png', '.bmp'];
const videoExtensions = ['.mp4', '.avi', '.wmv', '.mpg', '.gvf', '.mov'];
const previewableVideoExtensions = ['.mp4'];

export const isImage = (ext: string): boolean => {
  return imageExtensions.includes(ext);
};

export const isVideo = (ext: string): boolean => {
  return videoExtensions.includes(ext);
};

export const isPreviewableVideo = (ext: string): boolean => {
  return previewableVideoExtensions.includes(ext);
};

export const hasImage = (exts: string[]): boolean => {
  return exts.some((ext) => isImage(ext));
};

export const hasVideo = (exts: string[]): boolean => {
  return exts.some((ext) => isVideo(ext));
};

export const getFileExtension = (file: File): string => {
  const parts = file.name.split('.');
  return parts.length > 1 ? `.${(parts.pop() as string).toLowerCase()}` : '';
};

export const getAcceptFromExtensions = (
  acceptedExtensions: string,
): DropzoneAccept => {
  const accept: DropzoneAccept = {};

  const extensions = acceptedExtensions
    .split(',')
    .map((ext) => ext.trim().toLowerCase())
    .filter(Boolean);

  for (const ext of extensions) {
    const mime = extensionToMime[ext];
    if (mime) {
      if (!accept[mime]) {
        accept[mime] = [];
      }
      if (!accept[mime].includes(ext)) {
        accept[mime].push(ext);
      }
    }
  }

  return accept;
};

export const truncateFilename = (filename: string, maxLength = 30): string => {
  if (filename.length <= maxLength) return filename;

  const extIndex = filename.lastIndexOf('.');
  const hasExtension = extIndex > 0;
  const name = hasExtension ? filename.slice(0, extIndex) : filename;
  const extension = hasExtension ? filename.slice(extIndex) : '';

  const charsToShow = maxLength - 3 - extension.length;
  const front = Math.ceil(charsToShow / 2);
  const back = Math.floor(charsToShow / 2);

  return `${name.slice(0, front)}...${name.slice(name.length - back)}${extension}`;
};
